import React from 'react'
import './Footer.scss'

const Footer = () => {
  const date = new Date().getFullYear()
  return (
  <footer className="bg-white">
    <div>
        <div className="emp-footer-inner shadow bg-white text-center py-2 text-dark">
          &copy; Police Service Commission {date} - All Right Reserved.
        </div>
    </div>
  </footer>

  )
}

export default Footer
